module.exports = __webpack_public_path__ + "static/media/NBA2K18.9398faf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/NBA2K18/top/NBA2K18.mp4
// module id = aD0Q
// module chunks = 0